// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__5oTTf","icon":"Banner_icon__3cW3o","message":"Banner_message__G0ScS"};